/*********************
Recent Occurrence Rule
*********************/
import Rule from './Rule';
import { ruleInputTypes, ruleTypes } from '../../constants';
import { buildLogForRule } from '../../utils/logUtils';

// NOTE: this rule currently doesn't apply to word level interventions,
// as we don't have the necessary features to make a word-level determination
export default class RecentOccurrenceRule extends Rule {
  constructor(logic, interventionType) {
    super([],logic); // No required fields
    this.ruleType = ruleTypes.RECENT_OCCURRENCE;
    this.interventionType = interventionType;
  }

  // Override the default run rule
  run(state) {
    let recentOccurrenceCount = state.scores.recentOccurrenceCounts[this.interventionType];
    let meetsOccurrenceRule = this.logic(recentOccurrenceCount);

    return {
      stateMeetsRuleCondition: meetsOccurrenceRule,
      decisionContext: {[(this.ruleType + '_'+meetsOccurrenceRule)]: 'error met specified recentOccurence count condition = ' + recentOccurrenceCount},
      log: buildLogForRule(this, state, meetsOccurrenceRule, {recentOccurrenceCount}),
    }
  }
}